import { render, staticRenderFns } from "./admin-engagement-contact-request-alarm.vue?vue&type=template&id=58b2a21d&scoped=true&"
import script from "./admin-engagement-contact-request-alarm.vue?vue&type=script&lang=js&"
export * from "./admin-engagement-contact-request-alarm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b2a21d",
  null
  
)

export default component.exports